export const openFileInNewTab = (file: File, onError?: (error: unknown) => void) => {
	try {
		const url = URL.createObjectURL(file);

		window.open(url, '_blank', 'noopener,noreferrer');

		setTimeout(() => URL.revokeObjectURL(url), 10000);
	} catch (error) {
		onError?.(error);
	}
};
